module.exports = __webpack_public_path__ + "img/loader.09e04a15.gif";